require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-glenvill-60-year-anniversary.json") })
        }
      }, "path---news-glenvill-60-year-anniversary");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-glenvill-60-year-anniversary!./.cache/json/news-glenvill-60-year-anniversary.json
// module id = 815
// module chunks = 231608221292675